export default __webpack_public_path__ + "static/media/spark_35.ee533fdd.png";